function dcAdminFooterNavController($rootScope, $window) {
    const vm = this;
    vm.navBack = () => {
        if ($rootScope.getHistory().length > 1) {
            $window.history.back();
        }
    }
}
dcAdminFooterNavController.$inject = ['$rootScope', '$window'];
export default dcAdminFooterNavController;